import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import * as editTemplateActions from "../../../edit-template/store/edit-template-store.action";
import {Store} from "@ngrx/store";


export interface IGuideLineSuggestion{
    reason?:string;
    reference?:string;
    suggestion?:string;
    status:string;
    guideLineContent:string;
}

@Component({
  selector: 'app-suggestion-sidebar',
  templateUrl: './suggestion-sidebar.component.html',
  styleUrl: './suggestion-sidebar.component.scss'
})
export class SuggestionSidebarComponent implements OnDestroy{


    @Input() data:IGuideLineSuggestion;
    @Output() closeClicked: EventEmitter<void> = new EventEmitter<void>();

   /**
     * Constructor
     *
     */
    constructor(
      private _store:Store
    ) {}


    closeMenu(){
        this.closeClicked.emit();
    }



    ngOnDestroy(): void {
        this._store.dispatch(editTemplateActions.legalHubSuggestionDestroyed());
    }
}
